<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card" v-if="invoiceList && invoiceList.length > 0">
            <div class="card-header">
                <h4 class="card-title mdi mdi-file-document"> Invoices</h4>
                <h6 class="card-subtitle"></h6>
            </div>
            <div class="card-body collapse show">
                <div class="table-responsive">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0">
                            <th class="border-0">Invoice No</th>
                            <th class="border-0">Plan Description</th>
                            <th class="border-0">Created At</th>
                            <th class="border-0">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(invoice, index) in invoiceList">
                            <td class="hover text-info" @click="downloadFile(invoice.invoice_pdf)"><span class="text-danger"><i class="fa fa-file-pdf" @click="downloadFile(invoice.invoice_pdf)"></i> </span>
                                {{invoice.number}}
                            </td>
                            <td>{{invoice.lines.data[0].description}}</td>
                            <td>{{invoice.created | epoch}}</td>
                            <td class="text-uppercase">{{invoice.amount_paid/100}} {{invoice.currency}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="card-header">
                <h4 class="card-title text-muted">Currently there are no invoices.</h4>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';

    export default {
        name: "Invoice",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                invoiceList: []
            };
        },
        mounted() {
            this.getInvoices();
        },
        methods: {
            async getInvoices() {
                $(".preloader").fadeIn();
                let reply        = await this.$http.get(`/org/${this.currentOrg.id}/invoices`);
                $(".preloader").fadeOut();
                this.invoiceList = reply.data;
            },
            async downloadFile(url) {
                let link  = document.createElement('a');
                link.href = url;
                link.click();
            }
        }
    }
</script>

<style scoped>
    .hover {
        cursor: pointer;
    }

    .preloader {
        width: 100%;
        height: 100%;
        top: 0;
        left: 262px;
        position: fixed;
        z-index: 99999;
        background: #ffffff69;
    }
</style>
